import { Avatar, Button, Col, Form, Input, InputNumber, Modal, Radio, Row, Select, Space, Upload } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import EventEmitter from '../../utils/eventEmitter';
import { Badge } from 'flowbite-react';
import usePosOrderAPI from '../apis/posOrderAPI';
import useSessionAPI from '../apis/sessionAPI';


const MyFooter = ({ handleSaveClose, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveClose} type='primary'>Close Session</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};


const MyHeader = ({ totalAmount, totalOrder }) => {
  return (
    <div className='border-b-2 flex justify-between'>
      <h3>Close Session</h3>
      <div className='flex justify-between' style={{width: '30%'}}>
        <p>Total: <span>{totalOrder}</span></p>
        <p>Orders: <span>GHc {totalAmount.toFixed(2)}</span></p>
      </div>
    </div>
  )
}


const PosCloseSessionModal = ({error, success, state }) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orders, setOrders] = useState({payments: [], counted: 0, difference: 0, note: ''});
  const { closeSession } = useSessionAPI();
  


  const handleCancel = () => setIsModalOpen(false);
  
  const handleSaveClose = () => { 
    let note = form.getFieldValue('note');
    let validOrders = state.orders.filter(order => order.status === 'paid' && order.is_ordered === true);
    // validOrders.forEach((order, idx) => {
    //   validOrders[idx]['session_id'] = state.session_id;
    //   validOrders[idx]['pos_id'] = state.pos_id;
    //   validOrders[idx]['employee_id'] = state.employee_id;
    //   validOrders[idx]['note'] = note;
    // });
    let sessionOrders = {
      session_id: state.session_id,
      pos_id: state.pos_id,
      employee_id: state.employee_id,
      note: note,
      counted_amount: orders.counted,
      // orders: validOrders
    }
    closeSession('POS-2024-0004', sessionOrders, error, success);
  };



  useEffect(() => {
    EventEmitter.subscribe('close_session', data => {
      setOrders(data.orders);
      setIsModalOpen(data.open);
    });
    return () => EventEmitter.unsubscribe('close_session');
  },[])

  const onChangeCounted = (e, idx) => {
    let orders_ = {...orders};
    orders_.counted = e;
    orders_.difference = orders_.payments[idx].amount - orders_.counted;
    setOrders(orders_);
  };


  
  return (
    <Modal title={<MyHeader totalAmount={orders.totalPaid} totalOrder={orders.no_orders}/>} closable={false} width={1000} className='p-0 ' open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveClose={handleSaveClose}/>}>
      <Row className='mb-4'>
        <Col md={{span: 6}} lg={{span: 6}}>
          <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Payment Method</Badge>

          {orders.payments.map((line, idx) => <p key={idx}>{line.name}</p>)}
        </Col>
        <Col md={{span: 2}} lg={{span: 3}}>
          <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Expected</Badge>

          {orders.payments.map((line, idx) => <p key={idx}>GHc <span>{line.amount.toFixed(2)}</span></p>)}
        </Col>
         
        <Col md={{span: 3}} lg={{span: 3, offset: 1}}>
          <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Counted</Badge>
          {orders.payments.filter(payment => payment.is_cash === true ).map((line, idx) => <InputNumber key={idx} value={orders.counted} onChange={e => onChangeCounted(e, idx)} className='input-outline-none'/>)}
        </Col>
        <Col md={{span: 3, offset: 1}} lg={{span: 4}}>
          <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Difference</Badge>

          <p className='text-red-600'>{orders.difference}</p>
        </Col>
      </Row>
      <div className='mt-4'>
        <Form form={form}>
          <Form.Item label='Closing Note' name={'note'} className='font-semibold' labelCol={{span: 8}}>
            <Input.TextArea rows={10} className='font-normal' placeholder='Add closing note here'/>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}

export default PosCloseSessionModal;